<template>
	<div class="wrap wrap--products">
		<!-- 헤더 -->
		<main-header></main-header>

		<!-- 메인 -->
		<main class="main" role="main">
			<div class="inner">
                <h2 class="join-title">회원가입</h2>

				<div class="join-container">
					<!-- 가입 단계 표시 -->
					<nav class="join-step">
						<ul class="join-step-lists">
							<li class="list">
								<span class="badge">1</span>
								<span class="text">약관동의</span>
							</li>
							<li class="list list--on">
								<span class="badge">2</span>
								<span class="text">정보입력</span>
							</li>
							<li class="list">
								<span class="badge">3</span>
								<span class="text">가입완료</span>
							</li>
						</ul>
					</nav>
					<!-- 정보입력 -->
					<div class="join-row-wrap">
						<!-- 정보입련: 일반 -->
						<div class="join-row join-row--form">
							<div class="join-caption join-caption--center">
								<h3 class="title">회원정보 필수입력</h3>
							</div>
							<div role="table" class="join-table">
								<div role="rowgroup">
									<div role="row">
										<div role="columnheader">아이디(이메일)</div>
										<div role="cell">
											<!-- 이메일 폼 -->
											<div class="form-email">
												<input class="input" type="text" v-model="user.email1">
												<span class="text">@</span>
												<input class="input" type="text" v-model="user.email2">
												<select class="select" @input="user.email2 = $event.target.value">
													<option value="">직접입력</option>
													<option value="naver.com">naver.com</option>
													<option value="google.com">google.com</option>
												</select>
											</div>
										</div>
									</div>
									<div role="row">
										<div role="columnheader">비밀번호</div>
										<div role="cell">
											<input class="input" type="password" v-model="user.password">
											<small class="text-grey text-grey--right">(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)</small>
										</div>
									</div>
									<div role="row">
										<div role="columnheader">비밀번호 확인</div>
										<div role="cell">
											<input class="input" type="password" v-model="user.passwordConfirm">
										</div>
									</div>
									<!-- 일반 -->
									<div role="row">
										<div role="columnheader">
                                            <span v-if="['user','technician'].includes(user.code)">이름</span>
                                            <span v-if="user.code == 'company'">대표자이름</span>
                                        </div>
										<div role="cell">
											<input class="input" type="text" v-model="user.name">
										</div>
									</div>
									<div role="row">
										<div role="columnheader">닉네임</div>
										<div role="cell">
											<input class="input" type="text" v-model="user.nickname">
										</div>
									</div>
									<div role="row">
										<div role="columnheader">연락처</div>
										<div role="cell">
											<!-- 연락처 폼 -->
											<div class="form-tel">
												<select class="select" v-model="user.phone1"><option value="010">010</option></select>
												<span class="text"></span>
												<input class="input" type="tel" v-model="user.phone2">
												<span class="text"></span>
												<input class="input" type="tel" v-model="user.phone3">
											</div>
										</div>
									</div>
									
								</div>
							</div>
						</div>
                        <!-- 정보입력: 업체 -->
						<div class="join-row join-row--form" v-if="user.code == 'company'">
							<div class="join-caption join-caption--center">
								<h3 class="title">업체정보 필수입력</h3>
							</div>
							<div role="table" class="join-table">
								<div role="rowgroup">
									<!-- 업체 -->
									<div role="row">
										<div role="columnheader">업체명</div>
										<div role="cell">
											<input class="input" type="text" v-model="user.meta.companyName">
										</div>
									</div>
									<div role="row">
										<div role="columnheader">사업자등록번호</div>
										<div role="cell">
											<input class="input" type="text" v-model="user.meta.businessNumber">
										</div>
									</div>
									<div role="row">
										<div role="columnheader">사업자등록증</div>
										<div role="cell">
											<input class="input" type="file" @change="(event) => { user.meta.businessRegistration = event.target.files[0]; $forceUpdate(); }">
										</div>
									</div>
									<div role="row">
										<div role="columnheader">회사로고</div>
										<div role="cell">
											<input class="input" type="file" @change="(event) => { user.meta.logo = event.target.files[0]; $forceUpdate(); }">
											<img :src="createObjectURL(user.meta.logo)" />
										</div>
									</div>
									<div role="row">
										<div role="columnheader">주소</div>
										<div role="cell">
											<div class="form-address">
												<div class="form-address__postcode">
													<input class="input" type="text" v-model="user.postcode" placeholder="우편번호" readonly @click="onSearchPostcode">
													<button class="button button--primary" @click="onSearchPostcode">검색</button>
												</div>
												<input class="input" type="text" v-model="user.address1" placeholder="기본주소" readonly @click="onSearchPostcode">
												<input class="input" type="text" v-model="user.address2" placeholder="상세주소">
											</div>
										</div>
									</div>
									<div role="row">
										<div role="columnheader">고객센터연락처</div>
										<div role="cell">
											<input class="input" type="text" v-model="user.meta.companyPhone" :disabled="isSamePhone" placeholder="예) 000-0000-0000">
											<label class="check" style="margin-left:1rem;">
												<input class="input" type="checkbox" v-model="isSamePhone" @change="setCompanyPhone">
												<i class="icon"></i>
												<span class="text">연락처와 동일</span>
											</label>
										</div>
									</div>
									<div role="row">
										<div role="columnheader">고객센터이메일</div>
										<div role="cell" style="display:flex;align-items:center;">
											<input class="input" type="text" v-model="user.meta.companyEmail" :disabled="isSameEmail" placeholder="예) center@ssezip.com">
											<label class="check" style="margin-left:1rem;">
												<input class="input" type="checkbox" v-model="isSameEmail" @change="setCompanyEmail">
												<i class="icon"></i>
												<span class="text">아이디(이메일)과 동일</span>
											</label>
										</div>
									</div>
									<div role="row">
										<div role="columnheader">계좌번호</div>
										<div role="cell">
											<div class="form-flex">
												<input class="input" type="text" v-model="user.meta.bankAccountName" placeholder="예금주">
												<select class="select" v-model="user.meta.bankCode">
													<option :value="null">은행명</option>
													<option v-for="bank in banks" :key="bank.code" :value="bank.code" class="select">{{ bank.name }}</option>
												</select>
												<input class="input" type="text" v-model="user.meta.bankAccount" placeholder="계좌번호 (숫자만 입력)">
											</div>
										</div>
									</div>
									<div role="row">
										<div role="columnheader">인테리어시공</div>
										<div role="cell">
											<div class="check-wrap">
												<label class="check">
													<input class="input" type="checkbox" v-model="user.meta.interiorApplication">
													<i class="icon"></i>
													<span class="text">신청</span>
												</label>
											</div>
										</div>
									</div>
									<div role="row" v-if="user.meta.interiorApplication">
										<div role="columnheader">시공분야</div>
										<div role="cell">
											<div class="check-wrap">
												<label class="check">
													<input class="input" type="radio" v-model="user.meta.interiorType" value="종합인테리어">
													<i class="icon"></i>
													<span class="text">종합인테리어</span>
												</label>
												<label class="check">
													<input class="input" type="radio" v-model="user.meta.interiorType" value="부분인테리어">
													<i class="icon"></i>
													<span class="text">부분인테리어</span>
												</label>
											</div>
										</div>
									</div>
									<div role="row" v-if="user.meta.interiorApplication && user.meta.interiorType == '부분인테리어'">
										<div role="columnheader">부분인테리어 카테고리</div>
										<div role="cell">
											<div class="check-wrap">
												<label class="check" v-for="(category, index) in interiorCategories" :key="index">
													<input class="input" type="checkbox" v-model="user.meta.interiorCategories" :value="category">
													<i class="icon"></i>
													<span class="text">{{ category }}</span>
												</label>
											</div>
										</div>
									</div>
									<div role="row" v-if="user.meta.interiorApplication">
										<div role="columnheader">시공지역</div>
										<div role="cell">
											<div class="form-flex">
												<select class="select" v-model="sido" @input="gugun = null">
													<option :value="null">시/도</option>
													<option class="select" v-for="sido in SidoGugun" :key="sido.key">{{ sido.name }}</option>
												</select>
												<select class="select" v-model="gugun">
													<option :value="null">시/구/군</option>
													<option class="select" v-for="gugun in (SidoGugun.find(temp => temp.name == sido) || {}).gugun" :key="gugun.name">{{ gugun.name }}</option>
												</select>
												<button class="button button--primary" @click="area && !user.meta.interiorAreas.find(find => find == area) ? user.meta.interiorAreas.push(area) : true">추가</button>
											
												<span v-for="(area, index) in user.meta.interiorAreas" :key="index">
													{{ area }}
													<button @click="user.meta.interiorAreas.splice(index, 1)">X</button>
												</span>
											</div>
										</div>
									</div>
                                    
									<div role="row">
										<div role="columnheader">스토어판매</div>
										<div role="cell">
											<div class="check-wrap">
												<label class="check">
													<input class="input" type="checkbox" v-model="user.meta.storeApplication">
													<i class="icon"></i>
													<span class="text">신청</span>
												</label>
											</div>
										</div>
									</div>
                                    <div role="row">
										<div role="columnheader">시공경력</div>
										<div role="cell">
											<div class="form-flex">
												<input class="input" type="number" v-model="user.meta.interiorCareerYear" placeholder="연">
												<input class="input" type="number" v-model="user.meta.interiorCareerMonth" placeholder="월">
											</div>
										</div>
									</div>
                                    <div role="row">
										<div role="columnheader">기본소개</div>
										<div role="cell">
											<input class="input" type="text" v-model="user.meta.summary">
										</div>
									</div>
                                    <div role="row">
										<div role="columnheader">상세소개</div>
										<div role="cell">
                                            <naver-smarteditor v-model="user.meta.introduction"></naver-smarteditor>
										</div>
									</div>
								</div>
							</div>
						</div>

                        <!-- 기술자 정보 -->
                        <div class="join-row join-row--form" v-if="user.code == 'technician'">
							<div class="join-caption join-caption--center">
								<h3 class="title">기술자 필수입력</h3>
							</div>
							<div role="table" class="join-table">
								<div role="rowgroup">
									<div role="row">
										<div role="columnheader">시공분야</div>
										<div role="cell">
											<div class="check-wrap">
												<label class="check">
													<input class="input" type="radio" v-model="user.meta.interiorType" value="종합인테리어">
													<i class="icon"></i>
													<span class="text">종합인테리어</span>
												</label>
												<label class="check">
													<input class="input" type="radio" v-model="user.meta.interiorType" value="부분인테리어">
													<i class="icon"></i>
													<span class="text">부분인테리어</span>
												</label>
											</div>
										</div>
									</div>
                                    <div role="row" v-if="user.meta.interiorType == '부분인테리어'">
										<div role="columnheader">부분인테리어 카테고리</div>
										<div role="cell">
											<div class="check-wrap">
												<label class="check" v-for="(category, index) in interiorCategories" :key="index">
													<input class="input" type="checkbox" v-model="user.meta.interiorCategories" :value="category">
													<i class="icon"></i>
													<span class="text">{{ category }}</span>
												</label>
											</div>
										</div>
									</div>
									<div role="row">
										<div role="columnheader">시공지역</div>
										<div role="cell">
											<div class="form-flex">
												<select class="select" v-model="sido" @input="gugun = null">
													<option :value="null">시/도</option>
													<option class="select" v-for="sido in SidoGugun" :key="sido.key">{{ sido.name }}</option>
												</select>
												<select class="select" v-model="gugun">
													<option :value="null">시/구/군</option>
													<option class="select" v-for="gugun in (SidoGugun.find(find => find.name == sido) || {}).gugun" :key="gugun.name">{{ gugun.name }}</option>
												</select>
												<button class="button button--primary" @click="area && !user.meta.interiorAreas.find(find => find == area) ? user.meta.interiorAreas.push(area) : null">추가</button>
											
												<span v-for="(area, index) in user.meta.interiorAreas" :key="index">
													{{ area }}
													<button @click="user.meta.interiorAreas.splice(index, 1)">X</button>
												</span>
											</div>
										</div>
									</div>
									<div role="row">
										<div role="columnheader">시공경력</div>
										<div role="cell">
                                            <input class="input" type="number" v-model="user.meta.interiorCareerYear" placeholder="연">
                                            <input class="input" type="number" v-model="user.meta.interiorCareerMonth" placeholder="월">
										</div>
									</div>

                                    <div role="row">
										<div role="columnheader">프로필사진</div>
										<div role="cell">
											<input class="input" type="file" @change="(event) =>{ user.meta.photo = event.target.files[0]; $forceUpdate();}">
											<img :src="createObjectURL(user.meta.photo)" />
										</div>
									</div>
                                    <div role="row">
										<div role="columnheader">기본소개</div>
										<div role="cell">
											<input class="input" type="text" v-model="user.meta.summary">
										</div>
									</div>
                                    <div role="row">
										<div role="columnheader">자기소개</div>
										<div role="cell">
                                            <naver-smarteditor v-model="user.meta.introduction"></naver-smarteditor>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 하단버튼 -->
					<div class="bottom-button">
						<a class="button button--border-primary" href="" onclick="return false;" @click="$router.go(-1)"><span>취소하기</span></a>
						<a class="button button--primary" @click="join"><span>회원가입</span></a>
					</div>
				</div>
			</div>
		</main>
		
		<daum-postcode ref="daum-postcode" @change="onChangePostcode"></daum-postcode>

		<!-- 푸터 -->
		<main-footer></main-footer>
	</div>
</template>

<script>
import api from "@/api";
import SidoGugun from "@/assets/data/sido-gugun.json";

import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";

import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import getGeolocation from '@/plugins/getGeolocation';
import banks from "@/assets/data/banks.json";

export default{
	components: {
		MainHeader,
		MainFooter,
        NaverSmarteditor,
		DaumPostcode
	},
	data(){
		return{
            SidoGugun,
			banks,

			user: {
                _terms: this.$store.state.agreements || [],
                
                code: this.$route.query.code,

                name: null,
				nickname: null,

				email1: null,
				email2: null,
                phone1: "010",
				phone2: null,
				phone3: null,
                password: null,
				passwordConfirm: null,
				
                postcode: null,
                address1: null,
                address2: null,

				geolocation: null,

                introduce: null,

                meta: {
                    photo: null,
                    logo: null,

					companyName: null,
					companyPhone: null,
					companyEmail: null,
					businessNumber: null,
                    businessRegistration: null,

                    interiorApplication: false,
                    interiorType: "",
					interiorAreas: [],
					interiorCategories: [],
                    interiorCareerYear: null,
                    interiorCareerMonth: null,

                    storeApplication: false,

					bankCode: null,
					bankAccount: null,
					bankAccountName: null,
                }
			},

            sido: null,
            gugun: null,

			interiorCategories : ['창호','욕실','주방','도배/페인트','마루/장판','도어/중문','조명','필름','기타'],

			isSamePhone: false,
			isSameEmail: false
		}
	},
	methods: {
		async join(){
			try{
				if(this.checkData()){
					var { user } = await api.v1.users.postUser({
                        ...this.user,
                        username: [this.user.email1, this.user.email2].join('@'),
                        email: [this.user.email1, this.user.email2].join('@'),
                        phone: [this.user.phone1, this.user.phone2, this.user.phone3].join('-'),
                        password: this.user.password,
                        passwordConfirm: null
                    });
                    
                    if(this.user.meta.businessRegistration) await api.v1.users.postBusinessRegistration(user, this.user.meta.businessRegistration);
                    if(this.user.meta.logo) await api.v1.users.postLogo(user, this.user.meta.logo);
                    if(this.user.meta.photo) await api.v1.users.postPhoto(user, this.user.meta.photo);

					this.$router.push("/join/complete");
				}
			}
			catch(error){
				console.error(error);
                alert(error.response ? error.response.data.message : error.message);
			}
		},

		onSearchPostcode(){
			this.$refs["daum-postcode"].open();
		},

		async onChangePostcode(data){
			this.user.postcode = data.postcode;
			this.user.address1 = data.address;

			this.user.geolocation = await getGeolocation(data.address);
		},

		setCompanyEmail() {
			if(this.isSameEmail) this.user.meta.companyEmail = [this.user.email1, this.user.email2].join('@');
		},
		setCompanyPhone() {
			if(this.isSamePhone) this.user.meta.companyPhone = [this.user.phone1, this.user.phone2, this.user.phone3].join('-');
		},

		checkPassword(password) {
			var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
			var checkEng = /[a-zA-Z]/;
			var checkNum = /[0-9]/;

			if(!checkSpecial.test(password)) throw new Error('비밀번호에 특수문자가 포함되어있어야합니다.');
			if(!checkEng.test(password)) throw new Error('비밀번호에 영문이 포함되어있어야합니다.');
			if(!checkNum.test(password)) throw new Error('비밀번호에 숫자가 포함되어있어야합니다.');

			if(password.length < 8 || 16 < password.length) throw new Error('비밀번호는 8~16자까지입니다.');

			return true;
		},

		checkData() {
			if(!this.user.email1 || !this.user.email2) throw new Error("아이디를 입력해주세요.");
			if(!this.user.password) throw new Error("비밀번호를 입력해주세요.");
			if(!this.checkPassword(this.user.password)) return false;
			if(!this.user.passwordConfirm) throw new Error("비밀번호 확인을 입력해주세요.");
			if(this.user.password != this.user.passwordConfirm) throw new Error("비밀번호를 확인해주세요");
			if(!this.user.phone1 || !this.user.phone2 || !this.user.phone3) throw new Error("연락처를 입력해주세요.");

			// 일반회원 체크
			if(this.user.code == "user") {
				if(!this.user.name) throw new Error("이름을 입력해주세요.");
				if(!this.user.nickname) throw new Error("닉네임을 입력해주세요.");
			}
			// 업체회원 체크
			else if(this.user.code == "company") {
                
				if(!this.user.name) throw new Error("대표자이름을 입력해주세요.");
				if(!this.user.nickname) throw new Error("닉네임을 입력해주세요.");
				if(!this.user.meta.companyName) throw new Error("업체명을 입력해주세요.");
                if(!this.user.meta.businessNumber) throw new Error("사업자 등록번호를 입력해주세요");
                if(!this.user.meta.businessRegistration) throw new Error("사업자 등록증을 업로드 해주세요");
                // if(!this.user.meta.logo) throw new Error("회사 로고를 업로드해주세요");
                if(!this.user.postcode || !this.user.address1) throw new Error("주소를 입력해주세요");
                if(!this.user.meta.companyPhone) throw new Error("고객센터 연락처를 입력해주세요");
                if(!this.user.meta.companyEmail) throw new Error("고객센터 이메일을 입력해주세요");
                if(!this.user.meta.bankAccountName) throw new Error("예금주를 입력해주세요");
                if(!this.user.meta.bankCode) throw new Error("은행코드를 입력해주세요");
                if(!this.user.meta.bankAccount) throw new Error("계좌번호를 입력해주세요");

                if(!this.user.meta.interiorApplication && !this.user.meta.storeApplication) throw new Error("서비스를 신청해주세요. ['인테리어시공', '스토어판매']");

                if(this.user.meta.interiorApplication){
                    if(this.user.meta.interiorAreas.length < 1) throw new Error("시공지역을 선택해주세요.");
                    if(this.user.meta.interiorType == "부분인테리어" && this.user.meta.interiorCategories.length < 1) throw new Error("시공분야를 선택해주세요.");
                }
			}
            // 기술자 회원 체크
            else if(this.user.code == "technician"){
                if(!this.user.name) throw new Error("이름을 입력해주세요.");
				if(!this.user.nickname) throw new Error("닉네임을 입력해주세요.");
                if(!this.user.meta.interiorType) throw new Error("시공분야를 선택해주세요");
                if(!this.user.meta.interiorAreas.length) throw new Error("시공지역을 선택해주세요");
                if(!this.user.meta.interiorCareerYear) throw new Error("시공경력을 선택해주세요");
                if(!this.user.meta.interiorCareerMonth) throw new Error("시공경력을 선택해주세요");
            }

			return true;
		},

		createObjectURL(file){
			return file ? URL.createObjectURL(file) : null;
		}
	},
    computed: {
        area(){
            if(this.sido && this.gugun) return `${this.sido}/${this.gugun}`;
            if(this.sido) return this.sido;
            return null;
        }
    }
}
</script>
